import dayjs, { parseWithWeekday } from '@/lib/dayjs';

const isDST = (date) => {
  const january = new Date(date.getFullYear(), 0, 1);
  const july = new Date(date.getFullYear(), 6, 1);
  const stdTimezoneOffset = Math.max(january.getTimezoneOffset(), july.getTimezoneOffset());
  return date.getTimezoneOffset() < stdTimezoneOffset;
}
const adjustForDST = (date, isDST) => {
  const offset = date.getTimezoneOffset() * 60000; // Convert offset to milliseconds

  if (isDST) {
    date.setTime(date.getTime() + 3600000); // Add one hour (in milliseconds) for DST
  } else {
    date.setTime(date.getTime() - 3600000); // Subtract one hour (in milliseconds) for standard time
  }

  // Adjust the date based on the offset
  date.setTime(date.getTime() + offset);

  return date;
}

export const isUrgentCheck = (booking, _deptDate) => {
  const deptDate = new Date(_deptDate)
  // deptDate gives us the startTime if we have or if not is default to 00:00:00
  if (
    booking &&
    booking.booking_information.fil === "M" &&
    deptDate &&
    booking.booking_information.vtdate_return
  ) {
    const isCurrentlyDST = isDST(deptDate); // Determine if DST is active
    const adjustedDate = adjustForDST(deptDate, isCurrentlyDST);
    // 24 Hours before Start Of trip
    const startTime = dayjs(adjustedDate).subtract(1, "days");
    const endTime = dayjs(new Date(`${booking.booking_information.vtdate_return} 23:59`)).add(1, "days");
    return dayjs().isBetween(startTime.format(), endTime.format());
  }
};

export const isHomeCheck = (booking) => {
  if (booking && booking.booking_information.vtdate_return) {
    const returnDate = parseWithWeekday(
      `${booking.booking_information.vtdate_return} 23:59`,
      "ddd DD MMM YYYY HH:mm"
    ).add(1, "days");
    return dayjs().isAfter(returnDate.format(), dayjs().format());
  }
  return false;
};
